import { render, staticRenderFns } from "./IssuesDetails.vue?vue&type=template&id=54b26511"
import script from "./IssuesDetails.vue?vue&type=script&lang=js"
export * from "./IssuesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports